import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { Button, Avatar, IconButton, Alert } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { axiosFetch } from "../../../utils/AxiosFetch";
import { useDispatch } from "react-redux";
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { load_UserDetails } from '../../../redux/actions/user.actions';
import { ChangeTeamModal } from '../MyAccount/Index';
import { ChangePassword } from '../../../shared/index';
import { Close } from "@mui/icons-material";
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import Settings from '@mui/icons-material/Settings';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  //padding: theme.spacing(2),
  //   height:320,
  textAlign: "center",
  color: theme.palette.text.secondary,
  borderColor: "black",
}));

function EmployeeList(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isRestore, setIsRestore] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [userId, setUserId] = useState("");
  const [isPswd, setIsPswd] = useState(false);
  const open = Boolean(anchorEl);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [onlyWarning, setOnlyWarning] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [pageData, setPageData] = useState({});
  const [passwordPopup, setPasswordPopup] = useState(false)


  const handleClick = (id, event, data) => {
    setUserId(id);
    setAnchorEl(event.currentTarget);
    setIsPswd(false);
    setPassword("");
    setConfirmPassword("");
    setPageData(data);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

  useEffect(() => {
    if (props.activeUsers === true) {
      setIsRestore(false)
    }
    else {
      setIsRestore(true)
    }
  }, [props.activeUsers])

  const handleClosePopup = () => {
    setOpenPopup(false)
    setAnchorEl(null)
  }
  const handleActivation = (type) => {
    var Method;
    if (type === "delete") {
      Method = "DELETE"
    }
    else {
      Method = "PUT"
    }
    var req = {
      Keyword: "",
      Alphabet: null,
      DepartmentName: "",
      JobTitle: "",
      Location: "",
      ReportingManagerId: "",
      IsActive: props.activeUsers,
      Page: 1,
      ResultsPerPage: 6,
    };
    axiosFetch({
      method: Method,
      url: `/employees/profile/${type}/${userId}`
    })
      .then((res) => {
        if (res.status === 200) {
          if (type === "restore") {
            dispatch(SnackbarActions(true, "success", " User restored successfully"))
          }
          if (type === "delete") {
            dispatch(SnackbarActions(true, "success", " User removed successfully"))
          }
          handleClosePopup()
          dispatch(load_UserDetails(req))
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleChangePassword = () => {
    setIsPswd(true)
    setOpenPopup(true)
  }

  const handleChangePwd = () => {
    var req = {
      "id": userId,
      "password": password
    }

    axiosFetch({
      method: 'POST',
      url: `/Account/changepassword`,
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(SnackbarActions(true, "success", " Password changed successfully"))
          handleClosePopup()
        }
        if (res.status === 400) {

          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        if (res.status === 401) {
          navigate("/");
        }

      })
      .catch(error => {
        console.log(error);
      });
  }
  const handleUserActive = () => {
    handleClose()
    if (pageData.isManager && pageData.teamCount > 0) {
      setOnlyWarning(true)
      handlePopup()
    }
    else {
      setOpenPopup(true)
    }
  }
  const handlePopup = () => {
    if (modalOpen) {
      setOnlyWarning(false)
      setModalOpen(false)
    }
    else {
      setModalOpen(true)
    }
  }
  const handlePassword = () => {
    if (passwordPopup) {
      setPasswordPopup(false)
    }
    else {
      setPasswordPopup(true)
      setAnchorEl(null)
    }
  }
  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {handleClosePopup ? (
                <IconButton
                    aria-label="close"
                    onClick={handleClosePopup}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};


  return (
    <div className="employee-container">
      <Box>
        <Grid container spacing={2}
        >
          {/* <Grid  className="stensil"  item xs={4}> */}
          {props.profiles.length > 0 ? (
            props.profiles.map((user) => {
              return (
                <Grid item xs={12} md={6} lg={4} xl={4} key={user.id}>
                  <Item className="employee-box">
                    <Avatar
                      className="stensil avtar-employee"
                      alt={user.firstName.toUpperCase()}
                      src={`/api/uploads/image/show/${user.profilePhotoName}`}
                    />
                    {isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR" ?
                      <>
                        <IconButton
                          className="option-icon"
                          size="small"
                          // id="demo-positioned-button"
                          aria-controls={open ? 'demo-positioned-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                          onClick={(e) => handleClick(user.id, e, user)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          // id="demo-positioned-menu"
                          aria-labelledby="demo-positioned-button"
                          anchorEl={anchorEl}
                          open={open}
                          className="employee-menu"
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}
                        >
                          {isRestore ?
                            <MenuItem sx={{borderBottom: "1px solid #ccc"}} onClick={() => setOpenPopup(true)}><ToggleOnIcon />  &nbsp; Activate</MenuItem> :
                            <MenuItem sx={{borderBottom: "1px solid #ccc"}} onClick={() => handleUserActive()}><ToggleOffIcon /> &nbsp; Deactivate</MenuItem>
                          }
                          {
                            isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR" ?<></>:
                            <MenuItem onClick={() => handlePassword()}><Settings fontSize="small" /> &nbsp; Change Password</MenuItem>

                          }
                        </Menu>
                      </> : <></>}
                    <h3 className="stensil employee-name">
                      {user.firstName + " " + user.lastName}
                    </h3>
                    <span className="stensil employee-content">{user.JobTitle}</span>
                    <span className="stensil employee-content"><strong>Department:</strong> {user.departmentName}</span>
                    <span title={user.emailId} className="stensil employee-content"
                    // style={{padding:"5px", overflow: "hidden", display:"inline-list-item",textDecoration:"none", color:"inherit",fontSize:"15px"}}
                    >
                      {user.emailId}
                    </span>
                    <span className="stensil employee-content">{user.location}</span>
                    {(isUserLogged.usertype === "Admin" || isUserLogged.usertype === "SuperAdmin" || isUserLogged.usertype === "HRManager" || isUserLogged.usertype === "HR" || user.isActive === true) ? <Link className="stensil employee-btn" to={`/users-profile/${user.id}`}>View Details</Link> : ""}
                  </Item>
                </Grid>
              );
            })
          ) : (
            <Grid
              xs={20}
              alignItems="center"
              display="flex"
              justifyContent="center"
              padding={20}
            >
              <Alert severity="error">
                No employee found
              </Alert>
            </Grid>
          )}
          {/* </Grid> */}
        </Grid>
      </Box>
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth="sm"
        maxWidth="sm"
      >
        <BootstrapDialogTitle className="modal-heading" id="alert-dialog-title">
          Are you sure you want to {isRestore ? "Activate" : "Deactivate"} this user ?
        </BootstrapDialogTitle>
        <hr />
        <DialogActions sx={{borderTop: "1px solid #ccc", paddingTop: "15px !important"}}>
          <Button onClick={() => handleClosePopup()} variant="outlined" className="theme-btn cancel-btn">No</Button>
          <Button onClick={() => handleActivation(isRestore ? "restore" : "delete")} variant="contained" className="theme-btn">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <ChangeTeamModal from="employeeList" userId={userId} open={modalOpen} handleClick={handlePopup} pageData={pageData} count={pageData.teamCount} changeManager={onlyWarning} />
      <ChangePassword handlePasswordPopup={handlePassword} open={passwordPopup} id={userId} />
    </div>
  );
}
export default EmployeeList;
